import NoValue from 'Components/Atoms/NoValue/NoValue';
import { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { useOuterClick } from 'Services/helpers';
import styles from './NumberField.module.sass';

interface NumberField {
    isEdit: any,
    value?: any,
    onChange: (value: string) => any,
    placeholder?: string
}

const NumberField = ({isEdit, value, onChange, placeholder}: NumberField) => {
    const [isFocused, setFocused] = useState(false);
    const inputRef: any = useRef();
    const innerRef = useOuterClick(() => setFocused(false));

    useEffect(() => {
        if (!isFocused) return;
        inputRef?.current?.focus();
    }, [isFocused]);

    return !isEdit
    ? <>{value || <NoValue/>}</>
    : <div className={`${styles['numberfield']} ${isFocused ? styles['numberfield--active'] : ''}`}
        onClick={() => setFocused(true)}
        ref={innerRef}
    >
        <div className={`${styles['numberfield__content']}`}>
            <input
                type="number"
                placeholder={placeholder}
                value={value || ''}
                onChange={(e) => onChange(e.target.value)}
                ref={inputRef}
            />
        </div>
    </div>;
}

export default connect(
    () => ({}),
    {}
)(NumberField);